export default __webpack_public_path__ + "assets/img/refer-a-friend-banner-uk.jpg";